import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import * as pas from '../pas';
import * as actions from '../store/actions';
import { useLoginRequest } from './useLoginRequest';
import { useAfterLoginAction } from './useAfterLoginAction';
import { useBeforeLoginAction } from './useBeforeLoginAction';
import { useFailedLoginAction } from './useFailedLoginAction';
import { useSuccessLoginAction } from './useSuccessLoginAction';
import { useGetWaitingMessages } from './useGetWaitingMessages';
import { useLoginBySessionToken } from './useLoginBySessionToken';
import { useRedirectToAfterLoginURL } from './useRedirectToAfterLoginURL';
import { useFailedVeridasLoginAction } from './useFailedVeridasLoginAction';

export const useLoginByGetParams = () => {
    const dispatch = useDispatch();
    const { languageCode } = useLoginRequest() || {};
    const beforeLoginAction = useBeforeLoginAction();
    const loginBySessionToken = useLoginBySessionToken();
    const afterLoginAction = useAfterLoginAction();
    const successLoginAction = useSuccessLoginAction();
    const failedLoginAction = useFailedLoginAction();
    const failedVeridasLoginAction = useFailedVeridasLoginAction();
    const redirectToAfterLoginURL = useRedirectToAfterLoginURL();
    const getWaitingMessages = useGetWaitingMessages();

    return useCallback(async (userName, tempToken, loginMode) => {
        dispatch(actions.setIsLoginInProcess(true));
        beforeLoginAction();

        try {
            await pas.setLoginType('SESSION_TOKEN');

            const pasLoginResponse = await pas.login({ userName, password: tempToken, languageCode, loginMode });
            const { username, sessionToken: { sessionToken } = {} } = pasLoginResponse?.data || {};

            await loginBySessionToken(username, sessionToken);
            await afterLoginAction();
            await successLoginAction({ userName: username, authType: 'token' });

            getWaitingMessages();
            redirectToAfterLoginURL();
        } catch (error) {
            failedLoginAction(error);
            failedVeridasLoginAction();
        } finally {
            dispatch(actions.setIsLoginInProcess(false));
            dispatch(actions.setAutoLoginCompleted());
        }
    }, [
        languageCode, dispatch, getWaitingMessages,
        loginBySessionToken, beforeLoginAction, afterLoginAction,
        successLoginAction, failedLoginAction, redirectToAfterLoginURL,
        failedVeridasLoginAction
    ]);
};
